"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.resetField = exports.clearField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _constants = require("../constants");

var _helpers = require("../helpers");

var _state = require("../state");

/**
 * Reset field, but ignoring default value
 * @param namespace
 * @param fieldName
 */
var clearField = function clearField(namespace, fieldName) {
  (0, _state.updateFieldStateWithCallback)(namespace, fieldName, function () {
    return (0, _extends2["default"])({}, _constants.FIELD_INITIAL_STATIC_VALUES, (0, _helpers.mapFieldValueAndError)(_constants.FIELD_DEFAULT_VALUE, _constants.FIELD_DEFAULT_ERROR));
  });
};
/**
 * Reset field to default state and setting last provided default value
 * @param namespace
 * @param fieldName
 */


exports.clearField = clearField;

var resetField = function resetField(namespace, fieldName) {
  // reset field to default state and setting last provided default value
  (0, _state.updateFieldStateWithCallback)(namespace, fieldName, function (currentState) {
    return (0, _extends2["default"])({}, _constants.FIELD_INITIAL_STATIC_VALUES, (0, _helpers.mapFieldValueAndError)(currentState[_constants.FIELD_KEY_DEFAULT_VALUE] || _constants.FIELD_DEFAULT_VALUE, currentState[_constants.FIELD_KEY_DEFAULT_VALUE_ERROR] || _constants.FIELD_DEFAULT_ERROR));
  });
};

exports.resetField = resetField;